import React from 'react';

const GiftProduct = ({ 
  imageSrc, 
  title, 
  details, 
  plecaText,
  className = "" 
}) => {
  return (
    <div className={`gift-product ${className}`}>
      <img src={imageSrc} className="img-fluid" alt={title} />
      <div className="description">
        <div className="title">{title}</div>
        <span>{details}</span>
      </div>
      <div className="pleca">{plecaText}</div>
    </div>
  );
};

export default GiftProduct; 